import { Navigate } from 'react-router-dom';

function CalendarFlow({ serviceJob, serviceProvider, location }) {
  return (
    <Navigate
      to={`/servicejobs/assign/${serviceJob.id}/${serviceProvider.id}/${location.id}`}
    />
  );
}

export default CalendarFlow;
